﻿import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import classes from "../maintainers.module.scss";

const AptitudesTableBody = ({ webPages }) => {
	const navigate = useNavigate();

	return (
		<div className={classes.maintainers_web}>
			{webPages &&
				webPages.map((wp, i) => {
					return (
						<div key={i} className={classes.page}>
							<div className={classes.page_content} onClick={() => navigate("/mantenedores/paginas_web/editar/" + wp.id)}>
								<Row>
									<Col md={8} xs={12} className={classes.resume}>
										{/* <div className={classes.title}>{wp.name}</div> */}
										<div className={classes.title}>{wp.name}</div>
										<div className={classes.subtitle}>Secciones</div>
										<div className={classes.content}>
											<ul>
												{wp.contents &&
													wp.contents.map((content, j) => {
														return <li key={j}>{content.name}</li>;
													})}
											</ul>
										</div>
									</Col>

									<Col md={4} xs={12} className={classes.metric}></Col>
								</Row>
							</div>
						</div>
					);
				})}
		</div>
	);
};

export default AptitudesTableBody;
